import { parseISO, toDate } from 'date-fns';
import React from 'react';
import { useSelector } from 'react-redux';

import useTimeZone from '@swf/core/hooks/useTimeZone';
import { select } from '@swf/core/store';

export type CustomDate = number | string;

export interface Props extends Intl.DateTimeFormatOptions {
  showTimeZone?: boolean;
  date: CustomDate;
}

const FormattedTimeZone: React.FC<Props> = ({ showTimeZone, date, ...rest }) => {
  const { timeZoneName } = useTimeZone();
  const locale = useSelector(select.locale.getIntlLocale);

  const dateTimeFormatOptions = {
    ...rest,
    timeZone: timeZoneName
  };

  const parsedDate = typeof date === 'string' ? parseISO(date) : toDate(date);
  const formattedDate = parsedDate.toLocaleString(locale, dateTimeFormatOptions);

  return (
    <time dateTime={formattedDate} suppressHydrationWarning>
      {formattedDate}
      {showTimeZone && ` ${timeZoneName.replace('_', ' ')}`}
    </time>
  );
};

export default FormattedTimeZone;
